const FETCH_PATIENT="FETCH_PATIENT";
const FETCH_PATIENT_ERROR="FETCH_PATIENT_ERROR";
const FETCH_PATIENT_SUCCESS="FETCH_PATIENT_SUCCESS";
const FETCH_STAFF="FETCH_STAFF";
const FETCH_STAFF_ERROR="FETCH_STAFF_ERROR";
const FETCH_STAFF_SUCCESS="FETCH_STAFF_SUCCESS"
const RESET="RESET";
export {FETCH_PATIENT, FETCH_PATIENT_ERROR, FETCH_PATIENT_SUCCESS,FETCH_STAFF,FETCH_STAFF_ERROR,FETCH_STAFF_SUCCESS,RESET};